import React from 'react';

// previewSrc — robust thumbnail URL chooser: s3_med_url isn't always
// populated (varies by element type and conversion state). Fall back to
// thumb / pixel-thumb / main URL so the operator never sees a broken
// glyph for a media that the player itself would still render.
export function previewSrc(m) {
  if (!m) return null;
  return (
    m.s3_med_url ||
    m.s3_thumb_url ||
    m.s3_pixel_thumbnail_url ||
    m.s3_url ||
    null
  );
}

// MediaPreview — renders an image OR a video element depending on the media
// type. Mirrors the gallery's ListItem rendering so the operator gets the
// same in-place playback behaviour for video previews. `fit` lets the
// caller pick between "cover" (gallery-style) and "contain" (form-style).
const MediaPreview = ({ media, fit = 'contain', className = '' }) => {
  if (!media) return null;
  const src = previewSrc(media);
  if (!src) return null;

  const style = {
    width: '100%',
    height: '100%',
    objectFit: fit,
    display: 'block',
  };

  // Type 1 = video. Use the thumb URL with a #t=2 fragment so the first
  // visible frame isn't a black "loading" image.
  if (media.type === 1) {
    return (
      <video
        className={className}
        src={`${src}#t=2`}
        preload="auto"
        muted
        loop
        autoPlay
        playsInline
        style={style}
      />
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={media.name || ''}
      style={style}
    />
  );
};

export default MediaPreview;
